import styled, { css } from 'styled-components'

import { fadeIn } from '../../components'

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`

export const AddressDialog = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 42.5rem;
  flex: 1;
  border: 1px solid gray;
  margin: 5rem 0;

  @media (min-width: 60rem) {
    min-width: 70%;
  }
`

export const AddressDialogHeader = styled.header`
  display: flex;
  align-items: center;
  justify-content: center;
  border-bottom: 1px solid ${props => (props.theme && props.theme.main && props.theme.main.general && props.theme.main.general.textNinethColor) || '#CCC'};
  padding: .5rem 1rem;
  position: relative;

  @media (min-width: 60rem) {
    display: none;
  }

  h1 {
    font-weight: bold;
    font-size: 1.25rem;
    color: ${ props => (props.theme && props.theme.main && props.theme.main.general && props.theme.main.general.textHighlightColor) || '#000' };
  }

  svg {
    position: absolute;
    left: 1rem;
    top: 50%;
    transform: translate(0, -50%);
    fill:${props => (props.theme && props.theme.main && props.theme.main.general && props.theme.main.general.textHighlightColor) || '#333'};

    path {
      stroke:${props => (props.theme && props.theme.main && props.theme.main.general && props.theme.main.general.textHighlightColor) || '#333'};
      fill:${props => (props.theme && props.theme.main && props.theme.main.general && props.theme.main.general.textHighlightColor) || '#333'};
    }
  }
`

export const AddressDialogTitle = styled.h2`
  font-weight: 700;
  font-size: 1.25rem;
  color: ${ props => (props.theme && props.theme.main && props.theme.main.general && props.theme.main.general.primaryColor) || '#000' };
  margin: 0 0 2rem 0;
`

export const AddressCardSideIcon = styled.aside`
  border-right: 1px solid rgba(206, 206, 206, .5);
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  padding: 0 .85rem 0 0;
  margin: 0 .85rem 0 0;

  @media (min-width: 20rem) {
    padding: 0 1.5rem 0 0;
    margin: 0 1.5rem 0 0;
  }

  svg {
    width: 1.5rem;
    height: 1.5rem;
  }
`

export const AddressCardContent = styled.main`
  flex: 1;
  min-width: 0;
  display: flex;
  flex-wrap: wrap;
`

const textOverflow  = css`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

export const StreetAddress = styled.h3`
  margin: 0;
  ${textOverflow}
`

export const NumberAddress = styled.h3`
  width: auto;
  text-align: start;
  margin: 0 0 0 .25rem;
`

export const AddressValue = styled.span`
  display: flex;
  align-items: center;
  overflow: hidden;
  width: 100%;

  ${StreetAddress}, ${NumberAddress} {
    font-weight: 600;
    font-size: 1rem;
    color: ${ props => (props.theme && props.theme.main && props.theme.main.general && props.theme.main.general.textHighlightColor) || '#000' }; 
  }
`

export const AddressState = styled.span`
  font-size: .875rem;
  line-height: 1.25rem;
  width: 100%;
  color: ${ props => (props.theme && props.theme.main && props.theme.main.general && props.theme.main.general.textPrimaryColor) || '#000' };
  ${textOverflow}
`

export const AddressAdditional = styled.span`
  font-size: .875rem;
  line-height: 1.25rem;
  color: ${ props => (props.theme && props.theme.main && props.theme.main.general && props.theme.main.general.textPrimaryColor) || '#000' };
  width: 100%;
  ${textOverflow}
`

export const AddressCardActions = styled.aside`
  margin: 0 0 0 .85rem;
  padding: 0 0 0 .85rem;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;

  @media (min-width: 20rem) {
    margin: 0 0 0 1.5rem;
  }

  svg {
    width: 1.5rem;
    height: 1.5rem;
    cursor: pointer;
  }
`

export const AddressCardEditionActions = styled.div`
  display: flex;
  align-items: center;
  border-left: 1px solid rgba(206, 206, 206, .5);
  height: 100%;

  svg {
    width: 1rem;
    height: 1rem;
    cursor: pointer;
    margin: 0 0 0 1rem;
  }
`

export const AddressCard = styled.li`
  list-style: none;
  display: flex;
  align-items: center;
  border: 2px solid ${props => (props.theme && props.theme.main && props.theme.main.general && props.theme.main.general.textNinethColor) || '#CCC'};
  border-radius: 15px;
  height: 2rem;
  padding: .5rem .85rem;
  cursor: pointer;

  @media (min-width: 20rem) {
    padding: 1rem 1.5rem;
  }

  &:hover {
    background-color: #f8f8f891;
  }

  &.active-address {
    border: 2px solid ${ props => (props.theme && props.theme.main && props.theme.main.general && props.theme.main.general.primaryColor) || '#000' };

    ${AddressCardSideIcon} {
      border-right-color: ${ props => (props.theme && props.theme.main && props.theme.main.general && props.theme.main.general.primaryColor) || '#000' };
      border-right-width: 2px;

      svg path {
        stroke: ${ props => (props.theme && props.theme.main && props.theme.main.general && props.theme.main.general.primaryColor) || '#000' };
      }
    }
  }
`

export const AddressList = styled.ul`
  display: flex;
  flex-direction: column;
  margin: 0;
  padding: 0;

  ${AddressCard} {
    margin: 0 0 1rem 0;
  }
`

export const AddAddressTitle = styled(AddressDialogTitle)`
  margin: 2rem 0;
`

export const CEPWrapper = styled.div`
  display: flex;
  align-items: center;
  margin: 0;
  flex: 1;

  input {
    width: 60%
  }
`

export const Button = styled.button `
  background: ${ props => (props.theme && props.theme.main && props.theme.main.general && props.theme.main.general.primaryColor) || '#000' };
  color: #fff;
  text-align: center;
  font-weight: 700;
  margin: 0 0 0 1rem;
  width: 6rem;
  height: 3rem;
  border: 0;
  border-radius: 15px;
  cursor: pointer;

  &:hover {
    background-color: ${ props => (props.theme && props.theme.main && props.theme.main.general && props.theme.main.general.primaryColor) || '#000' };
  }
`

export const CloseButton = styled.button`
  color: ${ props => (props.theme && props.theme.main && props.theme.main.general && props.theme.main.general.textHighlightColor) || '#000' };
  background: none;
  border: 0 none;
  padding: 0;
  margin: 0;
`

export const Wrapper = styled.div`
  background: #fff;
  display: flex;
  flex: 1;
  flex-direction: column;
  box-sizing: border-box;
  margin: 0 auto;
  align-items: flex-start;
  justify-content: flex-start;
  max-width: 100%;
  min-width: 100%;
  box-sizing: border-box;
  align-items: stretch;
	overflow-y: auto;
  
  * {
    font-family: 'Nunito', 'sans-serif';
  }

  > .close-button {
    flex: 1;
    align-self: flex-end;
    margin-bottom: 1.25rem;
    font-weight: bold;
    position: absolute;
  }

  > div {
    min-width: 100%;

    &#addresses-loading {
      padding-bottom: 0;
    }

    > div {
			&#addresses-postal-code-component {
				padding: 0;
			}

      &.fixed {
        background: #fff;
        padding: 1.25rem;
        position: fixed;
        top: calc(100% - 6.875rem);
        left: 0;
        width: 100%;
        box-shadow: 0 0 .625rem #e1e1e1;
        transform: translate(0, 0);
      }
    }

    > .overlay {
      min-width: 100%;

      > .postal-code {
        height: 17.813rem;
        min-height: 17.813rem;
        max-height: 17.813rem;
        top: calc(100% - 17.813rem);
        transform: translate(-50%, 0);
      }
    }
  }
`

export const H1 = styled.h1`
  color: ${ props => (props.theme && props.theme.main && props.theme.main.general && props.theme.main.general.textHighlightColor) || '#000' };
  margin: 0;
  padding: 0;
  font-size: 1.125rem;
  line-height: 1.25rem;
  font-weight: bold;
  min-width: 100%;
  text-align: center;
  border-bottom: #E1E1E1 .063rem solid;
`

export const ContentWrapper = styled.div`
  padding: 0 1.25rem;
  font-size: .875rem;
  min-width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 2rem;
  box-sizing: border-box;
  max-width: 100%;
  min-height: 100%;

  ${fadeIn}

  &.disabled {
    > ul {
      pointer-events: none;
    }
  }

  > h2 {
    margin-bottom: 1.25rem;
  }
`

export const ListWrapper = styled.ul`
  margin: 0 0 1rem 0;
  padding: 0;
  list-style: inside none;
`

export const ListItemWrapper = styled.li`
  display: grid;
  grid-gap: 0;
  grid-template-columns: 3.75rem calc(100% - (3.75rem + 5.938rem)) 5.938rem;
  grid-template-areas: 'icon address actions';

  border: ${ props => (props.theme && props.theme.main && props.theme.main.general && props.theme.main.general.textPrimaryColor) || '#000' } .125rem solid;
  border-radius: .938rem;
  padding: 0;
  margin-bottom: 1.25rem;
  transition: all .25s ease-in;
  position: relative;

  &:last-child {
    margin-bottom: 0;
  }

  > div {
    &.icon {
      min-height: 100%;
      display: flex;
      align-items: center;
      grid-area: icon;
      padding: 0 1.25rem;
      font-size: 1rem;
      cursor: pointer;

      > span {
        display: flex;
        align-items: center;
        flex: 1;
        min-height: 100%;
        border-right: ${ props => (props.theme && props.theme.main && props.theme.main.general && props.theme.main.general.textPrimaryColor) || '#000' } .125rem solid;
        padding-right: 1.25rem;
      }
    }
  }

  > div + p {
    padding-left: 1.25rem;
  }

  > div {
    &.address {
      grid-area: address;
      padding: .625rem 1.25rem;
      padding-right: 0;
      cursor: pointer;

      > p {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: flex-start;

        > span {
          &.first {
            flex: 1;
            font-size: 1rem;
            min-width: 100%;
            color: ${ props => (props.theme && props.theme.main && props.theme.main.general && props.theme.main.general.textPrimaryColor) || '#666' }; 
          }

          &.second {
            flex: 1;
            color: ${ props => (props.theme && props.theme.main && props.theme.main.general && props.theme.main.general.textPrimaryColor) || '#333' };
            font-size: .875rem;   
            min-width: 100%;
          }
        }
      }
    }
  }

  &.active {
    border: ${ props => (props.theme && props.theme.main && props.theme.main.general && props.theme.main.general.primaryColor) || '#000' } .125rem solid;

    > div {
      > span {
        border-right: ${ props => (props.theme && props.theme.main && props.theme.main.general && props.theme.main.general.primaryColor) || '#000' } .125rem solid;
        color: ${ props => (props.theme && props.theme.main && props.theme.main.general && props.theme.main.general.primaryColor) || '#000' };
      }

      > p {
        color: ${ props => (props.theme && props.theme.main && props.theme.main.general && props.theme.main.general.primaryColor) || '#000' };

        > span {
          &.first, &.second {
            color: ${ props => (props.theme && props.theme.main && props.theme.main.general && props.theme.main.general.primaryColor) || '#000' };
          }
        }
      }
    }

    > p {
      color: ${ props => (props.theme && props.theme.main && props.theme.main.general && props.theme.main.general.primaryColor) || '#000' };

      > span {
        color: ${ props => (props.theme && props.theme.main && props.theme.main.general && props.theme.main.general.primaryColor) || '#000' };
      }
    }
  }
`

export const ActionsWrapper = styled.div`
  grid-area: actions;
  padding: 0 1.25rem 0 1.25rem;
  min-height: 100%;
  transition: all .25s ease-in;
  display: flex;
  justify-content: flex-end;
  align-items: center;

  > div {
    > button {
      font-size: 1.25rem;
      background: #fff;
    }

    &.holder {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: flex-end;

      &.hide {
        display: none;
      }

      > button {
        font-size: .938rem;
        border: ${props => (props.theme && props.theme.main && props.theme.main.general && props.theme.main.general.textNinethColor) || '#333'} .063rem solid;
        border-radius: 50%;
        width: 1.563rem;
        height: 1.563rem;
        display: flex;
        align-items: center;
        justify-content: center;

        > span {
          flex: 1;
          min-height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;

          > svg {
            color: ${props => (props.theme && props.theme.main && props.theme.main.general && props.theme.main.general.textNinethColor) || '#333'};
            flex: 1;
          }
        }
      }
    }

    &.main {
      border-left: ${ props => (props.theme && props.theme.main && props.theme.main.general && props.theme.main.general.primaryColor) || '#000' } .125rem solid;
      padding-left: 1.25rem;
      min-height: 100%;
      display: flex;

      > button {
        margin-right: 1.25rem;
        padding: .625rem 0;

        &:last-child {
          margin-right: 0;
        }

        > span {
          > svg {
            color: ${ props => (props.theme && props.theme.main && props.theme.main.general && props.theme.main.general.primaryColor) || '#000' };
          }
        }
      }
    }
  }
`

export const Paragraph = styled.p`
  margin: 0;
  padding: 0;
`

export const Span = styled.span``

export const Div = styled.div``

export const LoadingWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;
  min-width: 100%;
  min-height: 100%;
`

export const LoadingImage = styled.img`
  width: 6.25rem;
  height: auto;
`

export const NewAddressButton = styled.button`
  color: ${ props => (props.theme && props.theme.main && props.theme.main.general && props.theme.main.general.invertedPrimaryColor) || '#fff' };
  background: ${ props => (props.theme && props.theme.main && props.theme.main.general && props.theme.main.general.primaryColor) || '#000' };
  border-radius: .938rem;
  font-weight: bold;
  flex: 1;
  max-height: 4.375rem;
  min-height: 4.375rem;
  line-height: 4.375rem;
  min-width: calc(100% - 2.5rem);
  max-width: calc(100% - 2.5rem);
  padding: 0;
  margin: 0;
  font-size: 1rem;
  box-sizing: border-box;
`
export const LoadingContainer = styled.div`
  height: 500px;
  min-height: 500px;
  width: 100%;
  display:flex;
  flex: 1;
`

export const MobileHeaderWrapper = styled.div`
  min-width: 100%;
	min-width: 100%;
	margin-left: -2rem;
	margin-right: -2rem;
	margin-top: -2rem;
	line-height: 4rem;
	max-height: 4rem;
	min-height: 4rem;
	box-sizing: border-box;
	display: flex;
	justify-content: center;
	align-item: center;
	margin-bottom: 2rem;
	position: relative;

	> button {
		min-width: 2rem;
		min-height: 2rem;
		max-width: 2rem;
		max-height: 2rem;
		position: absolute;
		left: 1rem;
		top: 50%;
		transform: translate(0, -50%);
		display: flex;
		justify-content: center;
		align-items: center;

		> svg {
			min-width: 100%;
			min-height: auto;
			display: flex;
		}
	}

	> h1 {
		display: flex;
		justify-content: center;
		align-item: center;
		max-height: 4rem;
		min-height: 4rem;
		line-height: 4rem;
	}

  @media (min-width: 40rem) {
    display: none;
  }
`
export const Notification = styled.div`
  border-radius: 1rem;
  padding: 1rem;
  background: ${ props => (props.theme && props.theme.main && props.theme.main.general && props.theme.main.general.textFifthColor) || '#EEE' };
  border: 0.15rem solid ${ props => (props.theme && props.theme.main && props.theme.main.general && props.theme.main.general.grey00) || '#CCC' };
  min-height: 3rem;
  max-height: 3rem;
  min-width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
	font-size: 1rem;
  color: ${ props => (props.theme && props.theme.main && props.theme.main.general && props.theme.main.general.textPrimaryColor) || '#333' };
  margin: 0 0 1rem;

  > img {
    width: 1rem;
    height: auto;
    min-width: 1rem;
    max-width: 1rem;
    min-height: auto;
    max-height: unset;
    margin-left: 1rem;
  }

	&.error {
		span.custom-icon {
			color: #f00;
			display: flex;
			align-items: center;
			justify-content: center;
			font-size: 1rem;

			> svg {
				background: none;
				min-height: 2rem;
				min-width: 2rem;
				margin-left: .5rem;
			}
		}

		svg {
			color:
		}
	}

  svg {
    width: 1.5rem;
    height: 1.5rem;
    min-width: 1.5rem;
    min-height: 1.5rem;
    background: #fd5b5d;
    border-radius: 50%;
    padding: .25rem;
    box-sizing: border-box;
    margin: 0 0 0 1rem;
  }
`
